import React from 'react';

import BenefitsSection from './components/BenefitsSection';
import HeroSection from './components/HeroSection';
import ReadyToGoGlobalSection from './components/ReadyToGoGlobalSection';
import SolutionsSection from './components/SolutionsSection';
import WorkflowSection from './components/WorkflowSection';
import type { ProductPageLayoutProps } from './types';

/**
 * Template component for product feature pages.
 * It combines various sections like hero, benefits, workflow, solutions, and CTA.
 */
const ProductPageLayout: React.FC<ProductPageLayoutProps> = ({
  // Hero section
  tag,
  title,
  description,
  ctaText,
  heroMedia,
  icon,

  // Benefits section
  benefitsSectionTitle,
  benefits,

  // How it works section
  howItWorksSectionTitle,
  steps,

  // Solution cards section
  solutionsSectionTitle,

  // Other props
  ...props
}) => {
  return (
    <div className="h-full bg-pray-primary px-4 md:px-10 lg:px-16" {...props}>
      <HeroSection
        icon={icon}
        tag={tag}
        title={title}
        description={description}
        ctaText={ctaText}
        heroMedia={heroMedia}
      />

      {benefits.length > 0 && <BenefitsSection benefitsSectionTitle={benefitsSectionTitle} benefits={benefits} />}

      {steps.length > 0 && <WorkflowSection howItWorksSectionTitle={howItWorksSectionTitle} steps={steps} />}

      <SolutionsSection solutionsSectionTitle={solutionsSectionTitle} />

      <ReadyToGoGlobalSection />
    </div>
  );
};

export default ProductPageLayout;
